import { render, staticRenderFns } from "./CreatePasscode.vue?vue&type=template&id=32558c8b&scoped=true"
import script from "./CreatePasscode.vue?vue&type=script&lang=js"
export * from "./CreatePasscode.vue?vue&type=script&lang=js"
import style0 from "./CreatePasscode.vue?vue&type=style&index=0&id=32558c8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32558c8b",
  null
  
)

export default component.exports